// extracted by mini-css-extract-plugin
export default {"badge":"f742920acc1e9f60df6b"};